module.exports = __webpack_public_path__ + "img/vertical_4_2_0.07a8b3fc.png";